import feedbackApi from './api';

export * from './api';
export default feedbackApi;
